import React, { memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { NEGATE_MODES } from '../../../../global/Predicates/Negate';
import Filter, { createFilterChangeHandler } from '../Filter';
import SimpleListPicker from '../ValueComponents/SimpleListPicker';
import { CustomFlowsActionCreators } from '../../../../../redux/actions/customFlows';

/** @typedef {import('../../../../global/Predicates/Negate').NegateMode} NegateMode */
/** @typedef {import('../../../../global/Predicates/TypeSelector').Type} Type */
/** @typedef {import('../../../../global/Predicates/ComparatorSelector').Comparator} Comparator */
/** @typedef {import('packages/dashboard/src/components/global/ListSelector').List} List */
/** @typedef {import('../../../../../redux/reducers').RootState} CustomFlowsRootState */

const {
  getAllFlows: getAllFlowsActions,
} = CustomFlowsActionCreators;

const getDefaultNegate = () => ({ mode: NEGATE_MODES.no });
const getDefaultComparator = (comparators) => comparators[0].value;
const getDefaultValue = () => [];

export const valueMapper = ({
  id, value, ...rest
}) => ({
  ...(value && { value: value.map((list) => list.id) }),
  ...rest,
});

/**
 * @param {Object} props
 * @param {String} props.id
 * @param {Function} props.onChange
 * @param {List[]} props.value
 * @param {NegateMode} props.negate
 * @param {String} props.type
 * @param {Type[]} props.types
 * @param {String} props.comparator
 * @param {Comparator[]} props.comparators
 */
const ActiveCampaignsFilter = (props) => {
  const dispatch = useDispatch();

  const {
    flowsLoaded,
    flows,
  } = useSelector((/** @type {CustomFlowsRootState} */state) => state.CustomFlowsReducer);

  if (!flowsLoaded) {
    dispatch(getAllFlowsActions(false));
    return <>Loading...</>;
  }

  const SELECT_OPTIONS = flows.map((flow) => ({
    id: flow.id,
    name: flow.name,
  })).sort((a, b) => a.name.localeCompare(b.name));

  const {
    type,
    types,
    value = getDefaultValue(),
    negate = getDefaultNegate(),
    comparators,
    onChange,
    id,
  } = props;

  // Destructure these seperately because we need to know the `type` to get the defaults
  const {
    comparator = getDefaultComparator(comparators),
  } = props;

  const onFilterChange = createFilterChangeHandler({
    id, type, value, negate, comparator, onChange,
  });

  return (
    <Filter
      negate={negate}
      comparator={comparator}
      type={type}
      onChange={onFilterChange}
      types={types}
      comparators={comparators}
      value={(
        <SimpleListPicker
          label="Automation"
          name="active campaign"
          value={value}
          onChange={onFilterChange}
          options={SELECT_OPTIONS}
        />
      )}
    />
  );
};

export default memo(ActiveCampaignsFilter);
